import { AttributesMixin, define, IOPromise, Model } from "@type-r/models";
import { MappingItem } from "../import-templates/models/import-template-details";
import { restfulIO } from "./endpoint";

export interface ImportTemplateModel extends AttributesMixin<typeof ImportTemplateModel> { }

@define
export class ImportTemplateModel extends Model {
    static endpoint = restfulIO('api/v1/ingest/jobs/parsed-file');

    static attributes = {
        parsedData: [[String]],
        mappingItems: Array
    };

    timeout(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    async waitForParsingToBeDone(fetchFn: () => IOPromise<this>, canWaitFn: () => IOPromise<boolean>) {
        try {
            const response = await fetchFn();
            return response;
        }
        catch {
            const canWait = await canWaitFn();
            if (canWait) {
                await this.timeout(3000);
                return await this.waitForParsingToBeDone(fetchFn, canWaitFn);
            }           
        }
    }

    parse(data: any) {
        try {            
            const headerRow = Object.keys(data[0]);
            const dataRows = data.map((row) => Object.values(row));
            return {
                parsedData: [headerRow, ...dataRows]
            };
        } catch (e) {
            return [[]];
        }
    }

    getObjectSubset = (obj, keys) => {
        const ret = Object.create(null);
        for (const k of keys) {
            ret[k] = obj[k];
        }
        return ret;
    } 

    async getParsedFile(options: object, mappingItems: MappingItem[]) {
        let canWait = true;
        let timer = setTimeout(() => canWait = false, 30000);

        try {
            this.mappingItems = mappingItems;
            return await this.waitForParsingToBeDone(() => this.fetch(options), () => Promise.resolve(canWait));
        } finally {
            clearInterval(timer);
        }        
    }
}
